import type { BetLegType } from '@ps/isp-web-services-types';
import { LegType } from '@ps/isp-web-services-types';

export function convertBetLegTypeToLegType(betLegType: BetLegType): LegType {
  switch (betLegType) {
    case 'SS':
      return LegType.SIMPLE_SELECTION;
    case 'SF':
      return LegType.FORECAST;
    case 'RF':
      return LegType.REVERSE_FORECAST;
    case 'CF':
      return LegType.COMBINATION_FORECAST;
    case 'TC':
      return LegType.TRICAST;
    case 'CT':
      return LegType.COMBINATION_TRICAST;
    case 'SC':
      return LegType.SCORECAST;
    default:
      return LegType.SIMPLE_SELECTION;
  }
}
